import { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import { api, fmtNGN } from "@/lib/api";

export default function AdminTransactions() {
  const [txns, setTxns] = useState([]);
  useEffect(() => { api.get("/admin/transactions").then((r) => setTxns(r.data)); }, []);
  return (
    <DashboardShell title="All transactions" subtitle="Platform-wide collections ledger.">
      <div className="card">
        {txns.length === 0 ? (
          <p className="text-sm text-[#4F5D4F] py-8 text-center">No transactions yet.</p>
        ) : (
          <table className="dense">
            <thead><tr><th>Date</th><th>Reference</th><th>School</th><th>Channel</th><th>Gross</th><th>Fee</th><th>Net</th></tr></thead>
            <tbody>
              {txns.map((t) => (
                <tr key={t.id} data-testid={`admin-txn-${t.id}`}>
                  <td>{new Date(t.created_at).toLocaleString()}</td>
                  <td className="font-mono text-xs">{t.reference}</td>
                  <td className="font-mono text-xs">{(t.school_id || "").slice(0, 8)}</td>
                  <td><span className="badge badge-info">{t.channel}</span></td>
                  <td className="font-mono">{fmtNGN(t.amount)}</td>
                  <td className="font-mono text-[#B45309]">-{fmtNGN(t.platform_fee)}</td>
                  <td className="font-mono text-[#2D7A5D]">{fmtNGN(t.net_to_school)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardShell>
  );
}
